import React, { useEffect, useState } from "react";
import profile_10 from "../../assets/images/profile-10.jpg";
import { Link, useLocation } from "react-router-dom";
import { BreadCrumb } from "../../assets";
import { resetLogin } from "../../stores/slices/loginSlice";
import { language } from "../../stores/slices/languageSlice";
import { resetApplicationsLists } from "../../stores/slices/applicationsSlice";
import { resetLookup } from "../../stores/slices/lookupSlice";
import { resetPortalMessages } from "../../stores/slices/portalMessagesSlice";
import { resetPreAuth } from "../../stores/slices/preAuthSlice";
import { resetRecentActivities } from "../../stores/slices/recentActivitiesSlice";
import { resetRequiredActions } from "../../stores/slices/requiredActionsSlice";
import { resetAppViewDetails } from "../../stores/slices/appViewDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Space, Switch } from "antd";
import { Bell, UserCheck, LogOut } from "react-feather";
import { useNavigate } from "react-router-dom";
import { setIsPortalMessage } from "../../stores/slices/portalMessagesSlice";
import { Modal } from "antd";
import Input from "../input/Input";
import validateInput from "../../utilities/validations/validateInput";
import { updateEmailAPI, setIsEmailUpdate } from '../../stores/slices/portalUserEmailUpdate/portalUserEmailUpdateSlice';
import { toast } from "react-toastify";
import { fetchLogOut } from "../../stores/slices/generalConfiguration/logOutSlice";
import { setIntervalClosing } from "../../utilities/sessionManagement";
import { clearInterval } from 'worker-timers'
import { getAllSessions } from "../../utilities/API/supertokenServices";
import Session from "supertokens-web-js/recipe/session";
// import { caseLogOut } from "../../utilities/API/caseServices";
import { iframe } from "../../container/iFrame";

function TopBar() {
  const createPatientLanguage =
    useSelector(language).PatientSearch.createPatient;
  const errorMessage = useSelector(language).errorMessage;
  const selectedLanguage = useSelector(language).Topbar;
  const checkedStatus = useSelector((state) => state.languages.checkedStatus);
  const loginData = useSelector((state) => state.loginSlice);
  const sessionData = useSelector((state) => state.sessionSlice)
  const portalMessage = useSelector((state) => state.portalMessagesSlice);
  const portalUserEmailUpdateStore = useSelector((state) => state.portalUserEmailUpdateSlice)
  const [logOutBtnDisable, setLogOutBtnDisable] = useState(false)
  const BrowserId = useSelector(state => state.preAuthSlice.browserToken)
  const portalUserID = useSelector(state => state.loginSlice.value.PortalUserID)
  const [updateEmail, setUpdateEmail] = useState({
    email: {
      value: "",
      isValid: true,
    },
  });
  const [emailModal, setEmailModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLogOutBtnDisable(false)
    setUpdateEmail({
      email: {
        value: loginData.Email,
        isValid: true,
      },
    });
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
 const deleteAllCookies = () => {
    document.cookie.split(';').forEach(cookie => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
  }
  const btnLogout = async (param) => {
    setLogOutBtnDisable(true)
    loginData?.rememberMeFlag != true && await Session.signOut();
    (param != "emailUpdated" || param == undefined) && toast.success("LogOut Successful");
    // loginData.rememberMeFlag != "true" && deleteAllCookies()
    dispatch(resetPreAuth());
    dispatch(resetLogin());
    dispatch(resetApplicationsLists());
    dispatch(resetLookup());
    dispatch(resetPortalMessages());
    dispatch(resetRecentActivities());
    dispatch(resetRequiredActions());
    dispatch(resetAppViewDetails());
    dispatch(fetchLogOut({ BrowserId, portalUserID }))
    setIntervalClosing(clearInterval)
    iframe()
    navigate("/");
    // caseLogOut(loginData?.CaseMgtUserID)
  };

  const handleToggle = (e) => {
    dispatch(language(e));
  };

  const inputOnChange = (e, fieldValidation) => {

    let inputValue = e.target.value;
    let inputName = e.target.name;

    let inputValidate = validateInput(inputValue, fieldValidation);
    setUpdateEmail((prevState) => ({
      ...prevState,
      [inputName]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid
      }
    }))

  }

  const emailUpdated = () => {
    dispatch(setIsEmailUpdate())
    btnLogout("emailUpdated")
  }

  portalUserEmailUpdateStore.isEmailUpdated && emailUpdated()

  const updatePortalUserMail = () => {
    if (updateEmail.email.value != '' && updateEmail.email.isValid) {
      let data = {
        newEmail: updateEmail.email.value,
        existingEmail: loginData.value.EmailAddress,
      }
        dispatch(
          updateEmailAPI({ email: data, portalID: loginData.value.PortalUserID })
        )
    } else {
      toast.error(errorMessage.mandatoryFieldsToastErrorMessage)
    }


  }

  //Seperating Path Name for Breadcrumb
  let crumbLink = "";
  const crumbPathSplit = location.pathname
    .split("/")
    .filter((path) => path != "");
  const crumbPath = crumbPathSplit.map((crumb, index) => {
    crumbLink += `/${crumb}`;
    return crumbPathSplit[crumbPathSplit.length - 1] == crumb ? (
      <React.Fragment key={index + 1}>
        <BreadCrumb />{" "}
        <p
          className="px-1"
          style={{ textTransform: "capitalize", color: "black" }}
        >
          {crumb}
        </p>
      </React.Fragment>
    ) : (
      <React.Fragment key={index + 1}>
        <BreadCrumb />
        <Link
          className="px-1"
          to={crumbLink}
          style={{ textTransform: "capitalize" }}
        >
          {crumb}
        </Link>
      </React.Fragment>
    );
  });

  return (
    <div className="top-bar">
      {/* <!-- BEGIN: Breadcrumb --> */}
      <div className="-intro-x breadcrumb me-auto d-none d-sm-flex">
        {" "}
        <Link className="px-1">Portal</Link> {crumbPath}
      </div>
      {/* /* <!-- END: Breadcrumb --> */}

      {/* <div className='px-3'>
                <Space>
                    <Switch unCheckedChildren="EN" checkedChildren="SP" onChange={handleToggle} defaultChecked={checkedStatus} />
                </Space>
            </div> */}

      {/* <!-- BEGIN: Account Menu --> */}
      <div id="myBtn" class="intro-x dropdown me-auto me-sm-6">
        <div
          class="dropdown-toggle notification notification--bullet cursor-pointer"
          role="button"
          aria-expanded="false"
          data-bs-toggle="dropdown"
          onClick={() => {
            dispatch(setIsPortalMessage(true));
          }}
        >
          <Bell class="notification__icon dark-text-gray-300" />{" "}
        </div>
      </div>
      {/* <!-- END: Notifications -->
                    <!-- BEGIN: Account Menu --> */}
      <div class="intro-x position-relative me-3 me-sm-6">
        <div
          class="box px-5 py-3 d-flex align-items-center zoom-in rounded-pill"
          onClick={() => setEmailModal(true)}
        >
          <div class="d-flex">
            <UserCheck class="notification__icon dark-text-gray-300" />
            <p class="px-3">{loginData.Email}</p>
          </div>
        </div>
      </div>
      {/* <!-- END: Search -->
                    <!-- BEGIN: Notifications --> */}
      <div class="intro-x ">
        {" "}
        <div class="intro-x">
          <div class="search d-none d-sm-block">
            <button class="btn btn-yellow fs-base " onClick={btnLogout} disabled={logOutBtnDisable}>
              <LogOut class="notification__icon dark-text-gray-300" />
              <p class="px-3">Log out</p>
            </button>
          </div>
        </div>
      </div>
      {/* <div div className="intro-x dropdown w-8 h-8">
                <div className="dropdown-toggle w-8 h-8 rounded-pill overflow-hidden shadow-lg image-fit zoom-in" role="button" aria-expanded="false" data-bs-toggle="dropdown">
                    <img alt="img" src={profile_10} />
                </div>
                <div className="dropdown-menu w-56">
                    <ul className="dropdown-content bg-theme-26 dark-bg-dark-6 text-white">
                        <li className="p-2">
                            <div className="fw-medium text-white">{selectedLanguage.heading}</div>
                            <div className="fs-xs text-theme-28 mt-0.5 dark-text-gray-600">{selectedLanguage.subHeading}</div>
                        </li>
                        <li>
                            <hr className="dropdown-divider border-theme-27 dark-border-dark-3" />
                        </li>
                        <li>
                            <a href="" className="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="user" className="w-4 h-4 me-2"></i> {selectedLanguage.Profile} </a>
                        </li>
                        <li>
                            <a href="" className="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="edit" className="w-4 h-4 me-2"></i> {selectedLanguage.addAccount} </a>
                        </li>
                        <li>
                            <a href="" className="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="lock" className="w-4 h-4 me-2"></i> {selectedLanguage.resetPassword} </a>
                        </li>
                        <li>
                            <a href="" className="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="help-circle" className="w-4 h-4 me-2"></i> {selectedLanguage.help} </a>
                        </li>
                        <li>
                            <hr className="dropdown-divider border-theme-27 dark-border-dark-3" />
                        </li>
                        <li>
                            <a href="" className="dropdown-item text-white bg-theme-1-hover dark-bg-dark-3-hover"> <i data-feather="toggle-right" className="w-4 h-4 me-2"></i> {selectedLanguage.logout} </a>
                        </li>
                    </ul>
                </div>
            </div> */}
      {/* <!-- END: Account Menu --> */}

      {/* Portal Message */}

      <Modal
        title=""
        open={portalMessage.isDashboardPortalMessage}
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={() => {
          dispatch(setIsPortalMessage(false));
        }}
        onCancel={() => {
          dispatch(setIsPortalMessage(false));
        }}
        width={800}
        cancelText="No"
        maskClosable={true}
        closeIcon={false}
        okText="Ok"
        centered
      >
        {portalMessage.dashboardPortalMessage.length > 0 ? (
          <ul style={{ listStyle: "circle" }} className="modal_style">
            {portalMessage.dashboardPortalMessage.map((data) => {
              return <li>{data}</li>;
            })}
          </ul>
        ) : (
          <p>No Notification's</p>
        )}
      </Modal>

      {/* E-Mail update  */}
      <Modal
        title="Update Email"
        open={emailModal}
        onOk={() => { updatePortalUserMail() }}
        onCancel={() => {
          setUpdateEmail({
            email: {
              value: loginData.Email,
              isValid: true,
            },
          });
          setEmailModal(false);
        }}
        width={800}
        cancelText="Cancel"
        maskClosable={true}
        closeIcon={false}
        okText="Update"
        centered
      >
        <Input
          id="email"
          type="text"
          name="email"
          label={createPatientLanguage.email}
          value={updateEmail.email.value}
          isValid={updateEmail.email.isValid}
          errorMsg={errorMessage.inputErrorMessage}
          onChange={(e) => inputOnChange(e, "email")}
          maxLength="100"
        />
      </Modal>
    </div>
  );
}

export default TopBar;
